import AvatarList from './avatar-list.vue';
export default AvatarList;


// WEBPACK FOOTER //
// ./src/components/avatar-list/index.js